export const imageToBase64 = (imageFile: File): Promise<any> => {
  return new Promise(resolve => {
    let baseURL;
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(imageFile);

    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
}